
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import UpdateListView from "./update-list.html";

angular.module("update", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('update', {
                url: "/update",
                abstract: true,
                cache: false,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('update.list', {
                url: "/list",
                cache: false,
                controller: "UpdateListCtrl",
                template: UpdateListView,
                data: { pageTitle: "Actualización" }
            })
        ;
    }])
;